import type { SidebarSection } from '@/common/CategorySidebar';

// The v3 posts API has no taxonomy/category endpoint, so these category
// sidebars are static presentation only — they are not backed by the API and
// do not filter the feed. If category filtering is ever needed, add a
// taxonomy endpoint and drive these from it.
//
// Every section heading and link label below is a user-facing English string
// with no key in public/locales/en/translation.json, hence the per-string
// `Translation Needed` markers. They come verbatim from the old site's
// sidebars; translating them is a separate content task.

export const newsCategoriesData: SidebarSection[] = [
  {
    // Translation Needed
    section: 'CATEGORIES:',
    links: [
      // Translation Needed
      'Devotionals',
      // Translation Needed
      'Announcements',
      // Translation Needed
      'Features',
      // Translation Needed
      "Coordinator's Corners",
      // Translation Needed
      'Action!',
      // Translation Needed
      'Course Information',
      // Translation Needed
      'Updates',
      // Translation Needed
      'Statistics',
      // Translation Needed
      'Success Stories',
    ],
  },
];

export const tutorialsSidebarData: SidebarSection[] = [
  {
    // Translation Needed
    section: 'Overview',
    links: [
      // Translation Needed
      'Study Helper Orientation',
      // Translation Needed
      'Study Helper Dashboard Overview',
      // Translation Needed
      'Help Icons',
      // Translation Needed
      'Changing your email address',
      // Translation Needed
      'Profile & Group Settings',
      // Translation Needed
      '"Should I Send Gifts?"',
      // Translation Needed
      '"What About Supporting Nationals?"',
      // Translation Needed
      'Recruiting New Study Helpers',
    ],
  },
  {
    // Translation Needed
    section: 'Seminars',
    // Translation Needed
    links: ['Seminar Recordings'],
  },
  {
    // Translation Needed
    section: 'Student Management',
    links: [
      // Translation Needed
      'Introducing Yourself',
      // Translation Needed
      'Grading and Certificates',
      // Translation Needed
      'Student Board – General',
      // Translation Needed
      'Student List',
      // Translation Needed
      'Student Board Overview',
      // Translation Needed
      'Activity & Course Progress',
      // Translation Needed
      'Timeline & Student Notes',
      // Translation Needed — possible match: t('wbs.adoption-requests')
      'Adoption Requests',
      // Translation Needed
      'Postal Records',
      // Translation Needed
      'Teaching Postal Students',
      // Translation Needed
      'Suggestions for Avoiding Scams',
    ],
  },
  {
    // Translation Needed
    section: 'WBS Connect',
    links: [
      // Translation Needed
      'Student Board for Connect',
      // Translation Needed
      'Campaigns',
      // Translation Needed
      'Web Targets',
    ],
  },
  {
    // Translation Needed
    section: 'Communication Tools',
    links: [
      // Translation Needed
      'Message System',
      // Translation Needed
      'Activity Feeds',
    ],
  },
  {
    // Translation Needed
    section: 'Follow Up',
    // Translation Needed
    links: ['Study Helper Follow-up Process'],
  },
  {
    // Translation Needed
    section: 'Coordinator Abilities',
    links: [
      // Translation Needed
      'Assign Students to A Study Helper',
      // Translation Needed
      'Group Roles',
    ],
  },
];
